import { useState } from 'react';
import { useAuth } from '../context/AuthContext.js';
import { createCustomerPortalSession } from '../services/api.js';
import { trackConversion } from '../services/conversionTracking.js';
import { CreditCardIcon } from './Icons.js';

interface ManageBillingButtonProps {
  variant?: 'primary' | 'secondary';
  className?: string;
}

export function ManageBillingButton({ variant = 'secondary', className = '' }: ManageBillingButtonProps) {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    if (!token) return;
    trackConversion('customer_portal_opened');
    setLoading(true);
    setError(null);
    try {
      const { url } = await createCustomerPortalSession(token);
      window.location.href = url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to open billing portal');
      setLoading(false);
    }
  }

  return (
    <div className="mbb-wrap">
      <button
        className={`btn ${variant === 'primary' ? 'btn-primary' : 'btn-secondary'} btn-sm mbb-btn ${className}`}
        onClick={handleClick}
        disabled={loading || !token}
      >
        <CreditCardIcon className="mbb-icon" aria-hidden="true" />
        {loading ? 'Opening...' : 'Manage Billing'}
      </button>
      {error && <p className="mbb-error">{error}</p>}
    </div>
  );
}
